/*============================================================================
  Announcement Bar
  Fades between messages when more than one announcement block is enabled.
  Pauses on hover / keyboard focus, and jumps to the selected block in the
  theme editor.
==============================================================================*/
(function() {
  if (customElements.get('announcement-bar')) return;

  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.promo-text'));
      if (this.slides.length < 2) return;

      var seconds = parseInt(this.dataset.seconds, 10);
      this.delay = (seconds > 0 ? seconds : 3) * 1000;
      this.index = Math.max(0, this.slides.findIndex(function(slide) {
        return slide.classList.contains('active');
      }));

      this.pause = this.stop.bind(this);
      this.resume = this.start.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('mouseenter', this.pause);
      this.addEventListener('mouseleave', this.resume);
      this.addEventListener('focusin', this.pause);
      this.addEventListener('focusout', this.resume);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.resume);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      if (!this.onBlockSelect) return;
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.resume);
    }

    start() {
      this.stop();
      this.timer = setInterval(function() {
        this.show((this.index + 1) % this.slides.length);
      }.bind(this), this.delay);
    }

    stop() {
      clearInterval(this.timer);
    }

    show(index) {
      var current = this.slides[this.index];
      var next = this.slides[index];
      if (!next || next === current) return;

      this.setActive(current, false);
      this.setActive(next, true);
      this.index = index;
    }

    setActive(slide, active) {
      slide.classList.toggle('active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
        if (slide.tagName === 'A') slide.removeAttribute('tabindex');
      } else {
        slide.setAttribute('aria-hidden', 'true');
        if (slide.tagName === 'A') slide.setAttribute('tabindex', '-1');
      }
    }

    onBlockSelect(event) {
      var index = this.slides.indexOf(event.target);
      if (index === -1) return;
      this.stop();
      this.show(index);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
})();
